import { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { API_URL } from '../../server'
import './NotificationModal.css'

const NotificationModal = ({ show, handleClose }) => {
  const [loader, setlodaer] = useState(false)
  const [data, setdata] = useState([])
  const navigate = useNavigate()

  const gotodesktopsetting = () => {
    const registerid = sessionStorage.getItem('registerid')
    if (registerid === null) {
      navigate('/', {
        state: true
      })
    } else {
      navigate('SettingsMainScreen/SettingNotification', {
        state: 2
      })
    }
  }

  useEffect(() => {
    if (show) {
      getnotification()
    }
  }, [show])

  const getnotification = async () => {
    try {
      const registerid = sessionStorage.getItem('registerid')
      const token = sessionStorage.getItem('token')
      const myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/json')
      myHeaders.append('Authorization', 'Bearer ' + token)

      const raw = JSON.stringify({
        user_id: registerid
      })

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      }

      const response = await fetch(API_URL + 'getNotification', requestOptions)
      const data = await response.json()
      console.log('data notification', data)
      setlodaer(false)
      setdata(data)
    } catch (error) {
      console.log(error)
    }
  }

  function getRelativeTime (isoDate) {
    const now = new Date()
    const past = new Date(isoDate)
    const diffInMs = now - past // Difference in milliseconds
    const diffInSeconds = Math.floor(diffInMs / 1000)

    if (diffInSeconds < 60) {
      return `${diffInSeconds}s ago`
    }

    const diffInMinutes = Math.floor(diffInSeconds / 60)
    if (diffInMinutes < 60) {
      return `${diffInMinutes}m ago`
    }

    const diffInHours = Math.floor(diffInMinutes / 60)
    if (diffInHours < 24) {
      return `${diffInHours}h ago`
    }

    const diffInDays = Math.floor(diffInHours / 24)
    if (diffInDays < 7) {
      return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`
    }

    const diffInWeeks = Math.floor(diffInDays / 7)
    return `${diffInWeeks} week${diffInWeeks > 1 ? 's' : ''} ago`
  }

  return (
    <div>
      <Modal show={show} onHide={handleClose} className='items-center m-0'>
        <div className='modalbackgroundcolor p-4 rounded-3'>
          <div className='notificationmodal-cancelbutton'>
            <button
              type='button'
              className='btn btn-close ms-auto'
              onClick={handleClose}
            ></button>
          </div>
          <div className='notificationmodal-head'>
            <div className='notificationmodal-notification-text'>
              <span>Notifications</span>
            </div>
            <hr className='mt-3 mb-3' />
            <div
              className='notificationmodal-notificationsetting-conatiner'
              onClick={() => gotodesktopsetting()}
            >
              <div className='notificationmodal-notificationsetting-icon'>
                <img
                  src={require('../../Assets/images/setting.png')}
                  width={18}
                  height={18}
                />
                <span>Notification Settings</span>
              </div>
              <div>
                <img
                  src={require('../../Assets/images/Vector (2).png')}
                  width={9}
                  height={9}
                />
              </div>
            </div>
            <hr className='mt-3 mb-3' />
            <div className='notificationmodal-body'>
              {loader ? (
                <span>Loading..</span>
              ) : (
                <>
                  {data?.response?.length === 0 ||
                  data?.message === 'No notifications found.' ? (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%', // or a fixed height like '300px' if needed
                        textAlign: 'center',
                        padding: '20px',
                        marginTop: '50px'
                      }}
                    >
                      <p
                        style={{
                          fontSize: '18px',
                          fontWeight: 'bold',
                          marginBottom: '8px',
                          fontFamily: 'RecoletaBold'
                        }}
                      >
                        No new notifications
                      </p>
                      <p style={{ fontFamily: 'AvenirNextLTPro-Regular' }}>
                        You're all caught up. We'll let you know when something
                        new comes in.
                      </p>
                    </div>
                  ) : (
                    <>
                      {/* {data?.response?.map((items, index) => (
                        <div key={index} className='notificationmodal-card'>
                          <div className='notificationmodal-card-head'>
                            <div className='notificationmodaal-cardhead-text'
                              onClick={() => {
                                // items?.type == 'BookExpert' || items?.type == 'Course BookExpert' ? 
                                // navigate('/') : null
                              }}
                            >
                              <span>{items?.notificationData[0]?.body}</span>
                              <span>{getRelativeTime(items?.updatedAt)}</span>
                            </div>
                            <div className='notificationmodal-cardhead-dot'>
                              <span></span>
                            </div>
                          </div>

                        </div>
                      ))} */}
                      {data?.response?.map((items, index) => {
                        const notification = items?.notificationData?.[0]

                        return (
                          <div
                            key={index}
                            className='relative rounded-xl border border-gray-200 bg-[#FFFDFA] p-4 mb-4'
                          >
                            {/* Unread dot */}
                            {!items?.viewed && (
                              <span className='absolute top-4 right-4 h-2 w-2 rounded-full bg-red-700' />
                            )}

                            {/* Title */}
                            <h3 className='text-base font-semibold text-gray-900 mb-3'>
                              {notification?.body}
                            </h3>

                            {/* Name */}
                            <div className='flex items-center gap-2 text-sm text-gray-700 mb-2'>
                              <span>{notification?.name}</span>
                            </div>

                            {/* Date & Time */}
                            <div className='flex items-center gap-2 text-sm text-gray-700 mb-4'>
                              <span>{notification?.dateAndTime}</span>
                            </div>

                            {/* Divider */}
                            <div className='h-px bg-gray-200 mb-3' />

                            {/* Footer */}
                            <div className='flex items-center justify-between text-sm'>
                              <button
                                // onClick={() => navigate("/upcoming-sessions")}
                                onClick={() =>
                                  navigate(
                                    '/ExpertSessions/ExpertUpcomeingAndPastSessions'
                                  )
                                }
                                className='font-medium text-gray-900 hover:underline'
                              >
                                {/* View upcoming sessions → */}
                                Continue learning →
                              </button>

                              <span className='text-gray-500'>
                                {getRelativeTime(items?.updatedAt)}
                              </span>
                            </div>
                          </div>
                        )
                      })}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default NotificationModal

// onClick={() => navigate("/SettingsMainScreen/SettingLearningSession")}
